'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _util = require('../core/util');

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

cbCalamiteitenBanner.$inject = ['SessionStorageService'];



var _module = _angular2.default.module('cb.ui-components.cbCalamiteitenBanner', [_util2.default.name, 'ngSanitize']);

_module.directive('cbCalamiteitenBanner', cbCalamiteitenBanner);

function cbCalamiteitenBanner(SessionStorageService) {
    return {
        restrict: 'E',
        scope: {
            styling: '@',
            icon: '@',
            title: '@',
            text: '@',
            link: '@',
            cta: '@',
            id: '@?'
        },
        template: "<section class=\"container\">\r\n    <div class=\"calamiteiten-banner calamiteiten-banner--{{styling}}\">\r\n        <div class=\"calamiteiten-banner__container\">\r\n            <div class=\"calamiteiten-banner__icon-wrapper\">\r\n                <span class=\"icon icon--calamiteiten-{{icon}}\"></span>\r\n            </div>\r\n            <div class=\"calamiteiten-banner__text-wrapper\">\r\n                <h5 class=\"calamiteiten-banner__title\">{{title}}</h5>\r\n                <span ng-bind-html=\"text\"></span>\r\n                <a class=\"calamiteiten-banner__link link--no-underline link--arrow-right\" href=\"{{link}}\" ng-if=\"cta\">{{cta}}</a>\r\n            </div>\r\n            <div class=\"calamiteiten-banner__close-wrapper\">\r\n                <span class=\"icon icon--cross\" ng-click=\"close()\"></span>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</section>",
        link: function link(scope, element, attrs) {

            /**
             * 'Closes' the banner by removing the element. It will save the given ID (when provided) to
             * sessionStorage, used by Relay42 to determine if the user closed the banner.
             *
             * @returns {void}
             */
            scope.close = function () {
                if (scope.id) {
                    SessionStorageService.setData(scope.id, true);
                }

                element.remove();
                scope.$destroy();
            };
        }
    };
}

cbCalamiteitenBanner.$inject = ['SessionStorageService'];

exports.default = _module;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/cb-calamiteiten-banner.directive.js
// module id = 853
// module chunks = 0